import React, { useState } from "react";
import HealthTeam from "../assets/images/health-team.png";
import TeacherTeam from "../assets/images/teacher-team.png";
import CreativeTeam from "../assets/images/creative-economy-team.png";

const momentsData = [
  {
    category: "HEALTH",
    location: "ILORIN, NIGERIA",
    title:
      "Nine health startups and state officials co-created for shared progress",
    description:
      "Health-tech founders in Kwara State had been building products without government input. The state had been planning digital health initiatives without consulting the people building the tools. CcHUB enabled both sides to share the same table. What emerged was a Digital Health Roadmap covering 3.5 million residents, now under government review.",
    image: HealthTeam,
  },
  {
    category: "EDUCATION",
    location: "KENYA & NIGERIA",
    title: "90% of teachers are using technology to improve learning outcomes",
    description:
      "CcHUB's education practice exists to improve learning outcomes using technology. The Teachers Lounge, a 2,000-teacher professional learning community across Kenya and Nigeria, is where educators sharpen their practice, share what works, and adopt new tools together. In an assessment of 800 members, over 90% reported actively using at least one EdTech tool in class, and 81% reported increased professional confidence.",
    image: TeacherTeam,
  },
  {
    category: "CREATIVE INDUSTRIES",
    location: "LAGOS & PARIS",
    title:
      "640 women launched or scaled ventures through CcHUB's creative economy programs",
    description:
      "CcHUB's creative program connected working artists, designers, and producers to the commercial infrastructure most had never accessed, investor networks, IP guidance, distribution channels, and the operational systems that turn creative talent into a durable business.",
    image: CreativeTeam,
  },
];

const MomentsSection: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentItem = momentsData[currentIndex];

  return (
    <section id="scholarship-section">
      <div className="scholarship-header">
        <h2>
          <span className="yellow-highlight">Moments</span> that show what this{" "}
          <br />
          looks like <span className="yellow-highlight">on the ground</span>
        </h2>
      </div>

      <div className="scholarship-carousel-container">
        <div className="scholarship-card" key={currentIndex}>
          <div className="scholarship-content-left">
            <div className="category-tag">{currentItem.category}</div>
            <p className="location-text">{currentItem.location}</p>
            <h3>{currentItem.title}</h3>
            <p className="description-text">{currentItem.description}</p>

            <div className="scholarship-nav-indicators">
              {momentsData.map((_, index) => (
                <div
                  key={index}
                  className={`nav-dash ${index === currentIndex ? "active" : ""}`}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}
            </div>
          </div>

          <div className="scholarship-content-right">
            <div className="image-circle-container">
              <img
                src={currentItem.image}
                alt={currentItem.category}
                className="scholarship-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MomentsSection;
